// for pop up size guide only
let size_guide_loaded = false
$j(".size_guide-link").click(function(){
  if (size_guide_loaded == false){
    console.log('modal component',$j('#size_guide.popup__overlay'))
    // change content only when dynamic-size-chart class nv existed
    size_guide_url = $j('#size_guide.popup__overlay:not(.dynamic-size-chart) .popup__content').html().replace(/ /g, '')
    console.log("size_guide_url",size_guide_url)
    // console.log('is white space',/^\s*$/.test(size_guide_url))
    $j('#size_guide.popup__overlay .popup__content').html('')
    if (size_guide_url != '' && !(/^\s*$/.test(size_guide_url))){
        console.log('get page content')
        $j.ajax({
          url: size_guide_url,
          type: "GET",
          dataType: "html",
          success: function(pageResponse){
            let pageContent = ''
            for (e of $j(pageResponse)){
              if (e.id == 'MainContent'){
                pageContent = e
                break
              }
            }
            // let pageContent = $j(pageResponse).find("main");
            // console.log('pageContent',pageContent)
            // $j("#SalesPoint .modal__centered-content").removeClass("modal-loading")
  
            $j("#size_guide.popup__overlay .popup__content").html(pageContent);
            size_guide_loaded = true
            
          }
        })
      }
  }
});

// toggle active classes

function closePopup(element){
  // console.log('hi', element.getAttribute('data-modal-id'))
  $j("#"+element.getAttribute('data-modal-id')).removeClass("open")
  // console.log('modal',$j("#"+element.getAttribute('data-modal-id')))
}
